<template>
  <el-row class="container" style="height: 100%;">
    <!--头部-->
    <el-col :span="24" class="f fb topbar-wrap">
      <div class="f topbar-left">
        <a href="/" class="f topbar-logo">
          <!-- 共有-->

          <!-- 霍尼韦尔 私有 -->
          <img v-if="logo.length > 0" :src="logo" style="width: 60px;height: 60px;">
          <span class="topbar-title">
            珠海市金品创业共享平台安全管控平台
            <span v-if="version" v-html="version"></span>
          </span>
        </a>
      </div>

      <div class="f topbar-search">
        <el-select class="custom-select" clearable filterable  v-model="selectUrl" placeholder="快捷搜索您想找的菜单名称" @change="toPage(selectUrl)" >
          <div style="max-height: 300px;">
            <el-option v-for="item in menuList"  :key="item.path" :value="item.path" :label="item.name">
              <span style="float: left">{{ item.path }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.name }}</span>
            </el-option>
          </div>
        </el-select>
      </div>
      <div class="f topbar-account topbar-btn">
<!--        </div>-->
<!--        <div id="div_jituankanban" style="display: none;" v-has="'home:home:jtkb'" class="companys-board">-->
<!--          <router-link class="f video" to="/datastatic3">-->
<!--            <i class="fa fa-map" style="font-size: 20px;"></i>-->
<!--            集团看板-->
<!--          </router-link>-->
<!--        </div>-->
        <div v-has="'home:home:sjkb'" class="headerBOX data-board">
          <router-link class="f sise" to="/datastatic">
            <i class="icon_fn icon_fn1x1"></i>
            数据看板
          </router-link>
        </div>
        <div class="headerBOX four-color" v-has="'home:home:work'">
          <router-link class="f sise" to="/operationSupervision">
            <i class="fa fa-wrench" style="font-size: 20px;"></i>
            作业一张图
          </router-link>
        </div>
        <div v-has="'home:home:gass'" class="headerBOX data-board">
          <router-link class="f fourfigure" to="/gassAlarm">
            <i class="fa fa-skyatlas"></i>
            气体监测一张图
          </router-link>
        </div>
        <div v-has="'home:home:sst'" class="headerBOX four-color">
          <router-link class="f sise" :to="'/sisetu?enterpriseId='+enterpriseId">
            <i class="icon_fn icon_fn2x1"></i>
            四色图
          </router-link>
        </div>
        <router-link class="f messages" to="/messageList">
          <i class="el-icon-message-solid"></i>
          消息通知<span v-if="messageCount>0">({{ messageCount }})</span>
        </router-link>

        <exportFile ref="exportFile"> </exportFile>
        <router-link class="f helper" to="/static/企业安全生产管理平台操作手册.pdf" target="_blank">
          <i class="el-icon-s-management " style="font-size: 23px;"></i>
          帮助手册
        </router-link>
        <el-dropdown trigger="click">
          <span class="el-dropdown-link userinfo-inner">
            <i class="el-icon-user-solid"></i>
            {{ nickname }}
            <i class="el-icon-arrow-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <div @click="toPage('/user/profile')"><span style="color: #555;font-size: 14px;">个人信息</span></div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="toPage('/user/changepwd')"><span style="color: #555;font-size: 14px;">修改密码</span></div>
            </el-dropdown-item>
            <!--            <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>-->
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <el-badge is-dot class="f">
            <a href="javascript:void(0);" class="message" ></a>
        </el-badge>-->
        <a class="message2" title="退出登录" @click="logout">
          退出
          <i class="icon_fn icon_fn4x1"></i>
        </a>
      </div>
    </el-col>

    <!--中间-->
    <el-col class="main">
      <!--左侧导航-->
      <aside :class="{ isCollapse: $store.state.isCollapse }">
        <!--展开折叠开关-->
        <div class="menu-toggle" @click.prevent="collapse">
          <i class="fa fa-bars" v-show="!$store.state.isCollapse"></i>
          <i class="fa fa-bars fa-rotate-90" v-show="$store.state.isCollapse"></i>
        </div>
        <!--导航菜单-->
        <div class="navWrap">
          <!--<div class="navBox">-->
          <el-menu :default-active="activeRoute($route.path)" unique-opened router :collapse="$store.state.isCollapse" @select="selectmenu">
            <template v-for="(item, index) in $store.state.menus" v-if="item.menuShow">
              <el-submenu v-if="!item.leaf && item.children.length > 0" :index="index + ''" :key="index">
                <template slot="title">
                  <!-- 有且只有 parentId=0 即是第一级元素时才展示icon add by Neil 2021年1月20日09:42:39-->
                  <i v-if="item.parentId==0" :class="iconChange(item.iconCls)"></i>
                  <span slot="title">{{ item.name }}</span>
                </template>

                <menu-tree :menuData="item.children"></menu-tree>
                <!--<el-menu-item
                v-for="term in item.children"
                :key="term.path"
                :index="term.path+''"
                v-if="term.menuShow"
                :class="$route.path==term.path?'is-active':''"
              >
                <i :class="term.iconCls"></i>
                <span slot="title">{{term.name}}</span>
              </el-menu-item>-->
              </el-submenu>
              <el-menu-item :index="item.path" v-else-if="item.children.length>0" style="color:#204192">
                <!-- <i :class="item.iconCls ? item.iconCls : ''"></i> -->
                <span slot="title" style="color:#204192">{{ item.name }}</span>
              </el-menu-item>
              <!-- <el-menu-item
              v-else-if="item.leaf&&item.children&&item.children.length"
              :index="item.path+''"
              :class="$route.path==item.children[0].path?'is-active':''"
            >
              <i :class="item.iconCls"></i>
              <span slot="title">{{item.children[0].name}}</span>
            </el-menu-item> -->
            </template>
          </el-menu>
          <!--</div>-->
        </div>
      </aside>
      <!--右侧内容区-->
      <section class="content-container" :class="{ iscop: $store.state.isCollapse }">
        <div id="page">
          <layout-header></layout-header>
          <el-main id="elmain">
            <div class="hp bg">
              <transition name="main" mode="out-in">
                <router-view></router-view>
              </transition>
            </div>
          </el-main>
        </div>
      </section>
    </el-col>
  </el-row>
</template>

<script>
  import $const from '@/common/constant';
  import {
    bus
  } from '../bus.js';
  import API from '../api/api_user';
  import menuTree from '@/components/common/menuTree';
  import layoutHeader from '@/components/common/tabNav';
  import API_VER from '@/api/api_version';
  import api_user from "@/api/api_user.js";
  import API_MES from '@/api/security/target/api_meeting_message';
  import API_ENT from '@/api/api_enterprisebase';
  import ATT_API from '@/api/api_att';
  import exportFile from "@/pages/trainingManagement/component/exportFile/exportFile";
  import activeRoute from '@/assets/js/activeRoute.js';
  export default {
    name: 'home',
    components: {
      layoutHeader,
      menuTree,
      exportFile
    },
    created() {
      bus.$on('setNickName', text => {
        this.nickname = text;
      });

      bus.$on('goto', url => {
        if (url === '/login') {
          localStorage.removeItem('access-user');
          localStorage.removeItem('userinfo');
        }
        this.$router.push(url);
      });
      bus.$on('refreshmsgcount', () => {
        this.getMessages();
      });
    },
    data() {
      return {
        nickname: '',
        version: '',
        messageCount: 0,
        entName: '',
        logo: '',
        istangshan: true,
        sonCompanyList: [],
        parentToken: null,
        enterpriseId: JSON.parse(localStorage.getItem('userinfo')).enterpriseId,
        menuList:[],//菜单搜索
        selectUrl:''
      };
    },
    watch: {
      // 监听浏览器直接输入路由，将此路由添加到tabnavBox
      '$route.path': function(val) {
        this.selectmenu(this.$route.fullPath);
      }
    },
    methods: {
       activeRoute(path){
         return activeRoute[path] ? activeRoute[path] : path;
       },
      // 判断是否显示视频监控
      tangshan: function() {
        var userinfoStr = localStorage.getItem('userinfo');
        var userinfo = JSON.parse(userinfoStr);
        if (userinfo.enterpriseId === 122) {
          this.istangshan = false
        }
      },
      toPage(url) {
        this.$router.push(url);
      },
      iconChange(iconname) {
        switch (iconname) {
          case 'fa fa-pencil-square-o':
            iconname = 'icon_nav icon_nav1x1';

            break;
          case 'el-icon-message-solid':
            iconname = 'icon_nav icon_nav2x1';
            break;

          case 'fa fa-sitemap':
            iconname = 'icon_nav icon_nav3x1';
            break;

          case 'fa fa-universal-access':
            iconname = 'icon_nav icon_nav4x1';
            break;
          case 'fa fa-address-book':
            iconname = 'icon_nav icon_nav5x1';
            break;
          case 'fa fa-bolt':
            iconname = 'icon_nav icon_nav6x1';
            break;
          case 'fa fa-exclamation-triangle':
            iconname = 'icon_nav icon_nav7x1';
            break;
          case 'el-icon-warning':
            iconname = 'icon_nav icon_nav8x1';

            break;
          case 'fa fa-folder-o':
            iconname = 'icon_nav icon_nav9x1';
            break;
          case 'fa fa-users':
            iconname = 'icon_nav icon_nav10x1';
            break;
          case 'fa fa-fire-extinguisher':
            iconname = 'icon_nav icon_nav11x1';
            break;
          case 'el-icon-s-release':
            iconname = 'icon_nav icon_nav12x1';
            break;
          case 'fa fa-user-o':
            iconname = 'icon_nav icon_nav13x1';
            break;
        }
        return iconname;
      },
      selectmenu(key) {
        let router = this.$store.state.menus;
        let name = false;
        let _this = this;

        let navTitle2 = function(fullPath) {
          // 没有菜单的页面获取标题
          let path = '';
          if (fullPath.indexOf('?') != -1) {
            path = fullPath.slice(0, fullPath.indexOf('?')); // 去掉参数
          } else {
            path = fullPath;
          }
          _this.$store.state.tabnavBox.forEach(item => {
            // path有带参数并且参数不同时
            if (item.path.indexOf('?') != -1 && item.path.slice(0, fullPath.indexOf('?')) === path && item.path !==
              fullPath) {
              item.path = fullPath; // 重新赋值
              name = item.title;
            } else {
              let p = _this.$store.state.noMenuPages.filter(v => v.path === path);
              if (p && p.length > 0) name = p[0].title;

            }
          });
          return name;
        };

        let navTitle = function(path, routerARR) {
          // 左边菜单页面获取标题
          for (let i = 0; i < routerARR.length; i++) {
            if (routerARR[i].children.length > 0 || routerARR[i].path === path) {
              if (routerARR[i].path === path) {
                name = routerARR[i].name;
                break;
              }
              navTitle(path, routerARR[i].children);
            }
          }
          return name;
        };

        if (!key.startsWith('http')) {
          _this.$store.dispatch('addTab', {
            title: navTitle(key, router) || navTitle2(key),
            path: key
          });
        }
      },
      //折叠导航栏
      collapse() {
        this.$store.dispatch('collapse');
      },
      logout() {
        let that = this;
        this.$confirm('确认退出吗?', '提示', {
            confirmButtonClass: 'el-button--warning'
          })
          .then(() => {
            //确认
            that.loading = true;
            let token = localStorage.getItem('access-token');
            localStorage.removeItem('access-token');
            localStorage.removeItem('menus');
            localStorage.removeItem('removeOperation');
            localStorage.removeItem("parentToken")
            localStorage.removeItem("userinfo");
            API.logout({
              token: token
            }).then(function(res) {
              // that.$message.error({
              //   showClose: true,
              //   message: res.msg,
              //   duration: 2000
              // });

            });
           that.$router.go(); //用go刷新
          })
          .catch(() => {});
      },
      beforeunloadFn(e) {
        console.log('浏览器刷新了');
        return false;
      },
      getVersion() {
        let than = this;
        API_VER.newestData().then(function(res) {
          if (res && res.ve) {
            than.version = res.ve.version;
          }
        });
      },
      //获取未读消息数量
      getMessages() {
        API_MES.notReadNumber().then(res => {
          if (res) {
            this.messageCount = res.count;
          }
        });
      },
      //获取企业名称
      getEntName() {
        let than = this;
        API_ENT.findEntById(JSON.parse(localStorage.getItem('userinfo')).enterpriseId).then(res => {
          if (res && res.code == 0) {
            than.entName = res.ent.companyName;
            ATT_API.getAttByIds({
              ids: res.ent.logo
            }).then(res => {
              if (res.code == 0 && res.list && res.list.length > 0) {
                //处理照片列表
                res.list.forEach((o, i) => {
                  var file = {
                    id: o.id,
                    name: o.name,
                    //url要加点料
                    url: process.env.API_ROOT + '/api-base' + o.url
                  }
                  than.logo = file.url;
                });
              }
            });
            localStorage.setItem("enterpriseName", res.ent.companyName);
            var u = JSON.parse(localStorage.getItem("userinfo"));
            if (u.parentEnterpriseId == null || u.parentEnterpriseId == 0) {
              $('#div_jituankanban').show();
            } else {
              $('#div_jituankanban').hide();
            }
          }
        });
        //than.entName = localStorage.getItem("enterpriseName");
      },
      iniDataBoard() {
        var pcid = window.localStorage.getItem('parent-company-id');
        if (pcid == 0) {
          $('#div_jituankanban').show();
        } else {
          $('#div_jituankanban').hide();
        }
      },
      getSonCompany() {
        var that = this;
        that.sonCompanyList = [];
        API.getChildEntInnerUser({}).then(function(result) {
          if (result.data && result.data.length > 0) {
            that.sonCompanyList = result.data;
          }
        });
      },
      //子公司跳转
      handleCommand(item) {
        // var token="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2MTA1OTIzNjMsInVzZXJfbmFtZSI6InR0dHQiLCJqdGkiOiJiMTRhZGY4Ny02ODYzLTRiYTItYTI4Ny0xMDAzNThhYjg2NzAiLCJ1c2VyaW5mbyI6IntcImNvbXBhbnlUeXBlXCI6XCIwMVwiLFwicm9sZXNcIjpbe1wiaWRcIjo1NyxcImlzUGxhdGZvcm1Sb2xlXCI6MCxcInByb3BlcnR5XCI6XCIwXCJ9LHtcImlkXCI6NDYsXCJpc1BsYXRmb3JtUm9sZVwiOjAsXCJwcm9wZXJ0eVwiOlwiMFwifSx7XCJpZFwiOjQ1LFwiaXNQbGF0Zm9ybVJvbGVcIjowLFwicHJvcGVydHlcIjpcIjBcIn1dLFwidmVyc2lvblwiOlwiMFwiLFwiaXNOb3JtYWxVc2VyXCI6ZmFsc2UsXCJpc09wZXJhdGluZ1wiOmZhbHNlLFwicGFyZW50RW50ZXJwcmlzZUlkXCI6NzYsXCJyb2xlSWRzXCI6WzU3LDQ2LDQ1XSxcInBhcnRuZXJcIjpcInpoYW50b25nXCIsXCJuYW1lXCI6XCJ0dHR0XCIsXCJpZFwiOlwiMzMwXCIsXCJlbnRlcnByaXNlSWRcIjo4OCxcImVudEFkbWluXCI6MCxcInVzZXJuYW1lXCI6XCJ0dHR0XCJ9IiwiY2xpZW50X2lkIjoiYXBwIiwic2NvcGUiOlsicmVhZCIsIndyaXRlIl19.eqFHthByzdYKQ-26tF86vI4puV1ISCAo1qVy3gPYlrI";
        // localStorage.setItem("parentToken", localStorage.getItem("access-token"));
        // localStorage.setItem("access-token", "Bearer " +token);
        // let than=this;
        // than.getUserByToken(function(result){
        //     localStorage.setItem('userinfo',JSON.stringify(result))
        //     window.location.href="/dashboard?entid="+item;
        // });
        localStorage.setItem("parentToken", localStorage.getItem("access-token"))
        localStorage.setItem("parentperms", localStorage.getItem('perms'));
        this.handleLogin(item.loginName, item.loginPass);
      },
      getQueryString(name) { //取url上的id
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(decodeURI(r[2]));
        return null;
      },
      getParentToken() {
        if (localStorage.getItem("parentToken")) {
          this.parentToken = localStorage.getItem("parentToken");
        }
      },
      getUserByToken(func) {
        let that = this;
        API.getUserByToken().then(function(result) {
            console.log("result::::", result);
            func(result);
          })
          .catch(() => {

          });
      },
      //返回集团公司
      returnparent() {
        let than = this;
        localStorage.setItem("access-token", localStorage.getItem("parentToken"));
        localStorage.setItem("perms", localStorage.getItem("parentperms"));
        localStorage.removeItem("parentToken")
        localStorage.removeItem("parentperms")
        than.getUserByToken(function(result) {
          localStorage.setItem('userinfo', JSON.stringify(result))
          localStorage.setItem('parent-company-id', result.parentEnterpriseId);
          localStorage.setItem('oldVersion', result.version)
          window.location.href = "/dashboard";
        });
      },
      handleLogin(username, password) {
        let that = this;
        this.loading = true;
        let loginParams = new FormData();
        loginParams.append('client_id', 'app');
        loginParams.append('client_secret', '123456');
        loginParams.append('grant_type', 'password');
        loginParams.append('username', username);
        loginParams.append('password', password);
        loginParams.append('type', 'pc-app');
        loginParams.append('partner', 'zhantong');
        API.login(loginParams).then(
          function(result) {
            that.loading = false;
            if (result) {
              var userInfo = JSON.parse(result.userinfo);
              localStorage.setItem('access-token', 'Bearer ' + result.access_token);
              localStorage.setItem('userinfo', result.userinfo);
              localStorage.setItem('oldVersion', userInfo.version);
              localStorage.setItem('parent-company-id', userInfo.parentEnterpriseId);
              api_user.tokenUser().then(function(resulttokenUser) {
                localStorage.setItem('perms', JSON.stringify(resulttokenUser.perms));
                window.location.href = "/dashboard";
                // window.location.href="/dashboard";
              });

            } else {
              that.$message.error({
                showClose: true,
                message: result.msg || '登录失败',
                duration: 2000
              });
            }
          },
          function(err) {
            that.loading = false;
          }
        );
      },
     // 定义一个函数来递归提取有效路径
      extractPaths(routes) {
        let menuList = [];
        routes.forEach(route => {
          // 检查 path 是否有效
          if (route.path && route.path.trim() !== "") {
            menuList.push({
              path: route.path,
              name: route.name, // 如果有 name 属性，也加入
            });
          }
          // 如果有 children，则递归调用
          if (route.children && Array.isArray(route.children)) {
            menuList = menuList.concat(this.extractPaths(route.children));
          }
        });
        return menuList;
      }
    },
    mounted() {
      debugger
      let that = this;
      that.$store.state.menus = [];
      localStorage.removeItem('removeOperation');
      API.router().then(function(result) {
        let userInfo = JSON.parse(localStorage.getItem('userinfo'));
        if (userInfo.roleIds) {
          //如果用户角色身份为 EnterpriseAdmin（企业管理员）或者SubEnterpriseAdmin（子公司管理员）就只显示【权限管理】和【企业管理】
          let role = userInfo.roleIds.find(c => c == $const.SystemInitRole.EnterpriseAdmin || c == $const.SystemInitRole
            .SubEnterpriseAdmin);
          if (role != null && role != undefined) {
            result.router.forEach(c => {
              if (c.name == '权限管理') {
                that.$store.state.menus.push(c);
              }
              if (c.name == '企业管理') {
                let modifyC = c;
                let data = c.children.filter(child => child.id == 160 || child.id == 95);
                modifyC.children = data;
                that.$store.state.menus.push(modifyC);
              }
            });
          } else {
            that.$store.state.menus = result.router;
            //将所有菜单(不含目录)，放入搜索栏
            that.menuList=that.extractPaths(result.router);
          }
        } else {
          that.$store.state.menus = result.router;
        }
        // 刷新保留当前路径和首页
        that.$router.push(that.$route.fullPath);
        that.selectmenu(that.$route.fullPath);

        // 刷新只保留首页
        /*that.$router.push('/dashboard')
          that.selectmenu('/dashboard')*/
      });
      API.tokenUser()
        .then(function(result) {
          that.nickname = result.username;

          localStorage.setItem('perms', JSON.stringify(result.perms));
        })
        .catch(() => {
          localStorage.removeItem('access-token');
          localStorage.removeItem("userinfo");
          that.$router.go('/login'); //用go刷新
        });
      that.getVersion();
      //获取未读消息数量
      that.getMessages();
      that.iniDataBoard();
      that.getEntName();
      that.getSonCompany();
      that.getParentToken();
    },
    destroyed() {
      //页面销毁
      //debugger;
    }
  };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .icon_fn {
    display: inline-block;
    width: 21px;
    height: 21px;
    margin-right: 5px;
    background: url(../assets/images/main/icons2.png) no-repeat left top;
    vertical-align: middle;
  }

  .icon_video {
    display: inline-block;
    width: 21px;
    height: 21px;
    margin-right: 5px;
    background: url(../assets/images/main/icons2.png) no-repeat left top;
    vertical-align: middle;
  }

  .icon_fn.icon_fn1x1 {
    background-position: 0 0;
  }

  .icon_fn.icon_fn2x1 {
    background-position: -21px 0;
  }

  .icon_fn.icon_fn3x1 {
    background-position: -42px 0;
  }

  .icon_fn.icon_fn4x1 {
    background-position: -63px 0;
  }

  .icon_nav {
    display: inline-block;
    width: 23px;
    height: 23px;
    background: url(../assets/images/main/icons.png) no-repeat left top;
    vertical-align: middle;
  }

  .icon_nav.icon_nav1x1 {
    background-position: 0 0;
  }

  li.is-opened .icon_nav1x1,
  .icon_nav.icon_nav1x1:hover {
    background-position: 0 -23px;
  }

  .icon_nav.icon_nav2x1 {
    background-position: -23px 0;
  }

  li.is-opened .icon_nav2x1,
  .icon_nav.icon_nav2x1:hover {
    background-position: -23px -23px;
  }

  .icon_nav.icon_nav3x1 {
    background-position: -46px 0;
  }

  li.is-opened .icon_nav3x1,
  .icon_nav.icon_nav3x1:hover {
    background-position: -46px -23px;
  }

  .icon_nav.icon_nav4x1 {
    background-position: -69px 0;
  }

  li.is-opened .icon_nav4x1,
  .icon_nav.icon_nav4x1:hover {
    background-position: -69px -23px;
  }

  .icon_nav.icon_nav5x1 {
    background-position: -92px 0;
  }

  li.is-opened .icon_nav5x1,
  .icon_nav.icon_nav5x1:hover {
    background-position: -92px -23px;
  }

  .icon_nav.icon_nav6x1 {
    background-position: -115px 0;
  }

  li.is-opened .icon_nav6x1,
  .icon_nav.icon_nav6x1:hover {
    background-position: -115px -23px;
  }

  .icon_nav.icon_nav7x1 {
    background-position: -138px 0;
  }

  li.is-opened .icon_nav7x1,
  .icon_nav.icon_nav7x1:hover {
    background-position: -138px -23px;
  }

  .icon_nav.icon_nav8x1 {
    background-position: -161px 0;
  }

  li.is-opened .icon_nav8x1,
  .icon_nav.icon_nav8x1:hover {
    background-position: -161px -23px;
  }

  .icon_nav.icon_nav9x1 {
    background-position: -184px 0;
  }

  li.is-opened .icon_nav9x1,
  .icon_nav.icon_nav9x1:hover {
    background-position: -184px -23px;
  }

  .icon_nav.icon_nav10x1 {
    background-position: -207px 0;
  }

  li.is-opened .icon_nav10x1,
  .icon_nav.icon_nav10x1:hover {
    background-position: -207px -23px;
  }

  .icon_nav.icon_nav11x1 {
    background-position: -230px 0;
  }

  li.is-opened .icon_nav10x1,
  .icon_nav.icon_nav11x1:hover {
    background-position: -230px -23px;
  }
</style>

<style lang="scss">
  aside {
    width: 264px;
    transition: 0.5s;
    border-right: 1px solid #ddd;

    &.isCollapse {
      width: 60px;
      overflow: initial;

      .navWrap {
        width: 100%;
        overflow: initial;
        border-right: 1px solid #ddd;
      }
    }

    .navWrap {
      position: relative;
      width: 257px;
      height: calc(100% - 40px);
      overflow-y: auto;
      overflow-x: hidden;

    }

    .el-menu {
      height: 100%;
      border-radius: 0px;
      background-color: #fff;
      border-right: 0px;
    }

    .el-menu {
      width: 100%;
    }

    .el-menu--collapse {
      width: 60px;
    }

    .el-submenu {
      //border-bottom:2px solid #f4f4f4;
      background-color: #f4f4f4;

      &.is-active {
        position: relative;
      }

      .el-menu .is-active {
        border: none;
      }
    }

    .el-submenu .el-menu-item {
      min-width: 60px;
      background-color: #fff;
    }

    .el-menu .el-menu-item,
    .el-submenu .el-submenu__title {
      height: 50px;
      line-height: 50px;
      font-size: 14px;
      letter-spacing: 1px;
      background: #ffffff;

      i {
        margin-right: 12px;
      }
    }

    .icon {
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-right: 6px;
    }

    .el-menu .el-menu-item {
      height: 48px;
      line-height: 48px;
    }

    .el-menu .el-menu-item:hover,
    .el-submenu .el-menu-item.is-active {
      background: #f5f5f5;
      color: #2c64e3;
    }

    .el-submenu .el-submenu__title:hover,
    .el-submenu.is-opened>.el-submenu__title {
      background: #fff;
      color: $color;
    }

    // 事项管理
    .icon-matters {
      background: url(../assets/images/matters.png) no-repeat center;
    }

    .el-submenu .el-submenu__title:hover .icon-matters,
    .el-submenu.is-opened .el-submenu__title .icon-matters,
    .el-submenu.is-active .el-submenu__title .icon-matters {
      background: url(../assets/images/matters-active.png) no-repeat center;
    }

    // 企业管理
    .icon-ent {
      background: url(../assets/images/ent.png) no-repeat center;
    }

    .el-submenu .el-submenu__title:hover .icon-ent,
    .el-submenu.is-opened .el-submenu__title .icon-ent,
    .el-submenu.is-active .el-submenu__title .icon-ent {
      background: url(../assets/images/ent-active.png) no-repeat center;
    }

    // 隐患管理
    .icon-hidden {
      background: url(../assets/images/hidden.png) no-repeat center;
    }

    .el-submenu .el-submenu__title:hover .icon-hidden,
    .el-submenu.is-opened .el-submenu__title .icon-hidden,
    .el-submenu.is-active .el-submenu__title .icon-hidden {
      background: url(../assets/images/hidden-active.png) no-repeat center;
    }

    // 风险管控
    .icon-risk {
      background: url(../assets/images/risk.png) no-repeat center;
    }

    .el-submenu .el-submenu__title:hover .icon-risk,
    .el-submenu.is-opened .el-submenu__title .icon-risk,
    .el-submenu.is-active .el-submenu__title .icon-risk {
      background: url(../assets/images/risk-active.png) no-repeat center;
    }

    // 第三方管理
    .icon-third {
      background: url(../assets/images/third.png) no-repeat center;
    }

    .el-submenu .el-submenu__title:hover .icon-third,
    .el-submenu.is-opened .el-submenu__title .icon-third,
    .el-submenu.is-active .el-submenu__title .icon-third {
      background: url(../assets/images/third-active.png) no-repeat center;
    }

    // 权限管理
    .icon-permissions {
      background: url(../assets/images/permissions.png) no-repeat center;
    }

    .el-submenu .el-submenu__title:hover .icon-permissions,
    .el-submenu.is-opened .el-submenu__title .icon-permissions,
    .el-submenu.is-active .el-submenu__title .icon-permissions {
      background: url(../assets/images/permissions-active.png) no-repeat center;
    }

    .el-submenu .el-submenu__title:hover .fa,
    .el-submenu .el-submenu__title:hover .el-submenu__icon-arrow,
    .el-submenu.is-opened .el-submenu__title .fa,
    .el-submenu.is-opened .el-submenu__title .el-submenu__icon-arrow {
      color: $color;
    }

    .el-menu-item:hover i {
      color: #fff;
    }

    .el-submenu__icon-arrow {
      width: 15px;
      height: 15px;
      line-height: 15px;
      left: 210px !important;
      right: auto !important;
      background: url(../assets/images/main/icon_arrow.png) no-repeat left top;

      &::before {
        content: none;
      }
    }

    .is-opened .el-submenu__icon-arrow {
      background-position: right top;
    }

    .navWrap>.el-menu>.el-submenu:not(.is-opened)>.el-submenu__title .el-submenu__icon-arrow {
      transform: rotate(0deg) !important;
    }

    .navWrap>.el-menu>.el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow {
      transform: rotate(0deg) !important;
    }

    .el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow {
      transform: rotate(0deg) !important;
    }

    .el-submenu:not(.is-opened)>.el-submenu__title .el-submenu__icon-arrow {
      transform: rotate(180deg) !important;
    }
  }

  #page {
    // width: 100%;
    height: calc(100% - 40px);
    overflow: hidden;

    .tabnavBox {
      border: 0;
      box-shadow: none;
      //margin-bottom:14px;
      height: 50px;
      background: none;

      ul {
        padding-left: 21px;
        padding-right: 21px;
        height: 55px;
      }

      .tabnav {
        height: 40px;
        line-height: 40px;
        border: none;
        padding: 0 15px;
        margin: 0 10px 0 0;
        box-shadow: 0 4px 8px rgba(29, 68, 171, 0.1);
        font-size: 14px;

        border-radius: 0 0 7px 7px;

        &:nth-of-type(1) {
          a {
            white-space: normal;

            width: auto;

            &::before {
              content: '';
              background: url(../assets/images/main/iconhome.png) no-repeat center center;
              width: 18px;
              height: 18px;
              display: inline-block;
              vertical-align: middle;
              margin-right: 8px;
            }
          }
        }

        .el-icon-error {
          top: 42%;
          right: 0;
          width: 10px;
          height: 10px;
          transform: translate(-100%, -50%);
          vertical-align: middle;

          &::before {
            transition: transform 0.2s linear;
            content: '';
            width: 10px;
            height: 10px;
            display: inline-block;
            background: url(../assets/images/main/icon_close.png) no-repeat center center;
          }
        }

        .el-icon-error:hover::before {
          transform: rotate(90deg);
        }
      }

      .tabnav:hover,
      .tabnav.active {
        background: #fff;
        font-weight: bold;
        font-size: 16px;
      }

      .tabnav .active a {
        color: #333;
        font-size: 16px;
      }

      .tabnav a {
        color: #333;
        font-size: 14px;
      }
    }

    .el-tabs {
      width: 100%;
      height: 100%;

      .el-tabs__header {
        margin: 0;

        .el-tabs__item {
          color: #000;

          &.is-active {
            color: $color;
          }
        }
      }

      .el-tabs__content {
        height: calc(100% - 40px);

        .el-tab-pane {
          height: 100%;
        }
      }
    }
  }
</style>

<style lang="scss" scoped>
  .el-menu--vertical .el-menu--popup {
    .el-menu-item:hover {
      background-color: $color !important;
      color: #fff !important;
    }

    .el-menu-item:hover i {
      color: #fff;
    }
  }

  /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
  ::-webkit-scrollbar {
    width: 9px;
    height: 9px;
  }

  /*定义滚动条轨道*/
  ::-webkit-scrollbar-track {
    background-color: transparent;
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
  }

  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb {
    //background-color:#204192;
    // background-image: -webkit-linear-gradient(45deg,rgba(255,255,255,.4) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.4) 50%,rgba(255,255,255,.4) 75%,transparent 75%,transparent);
    //-webkit-border-radius: 2em;
    //-moz-border-radius: 2em;
    //border-radius: 2em
  }

  .container {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    min-width: 1600px;

    .topbar-wrap {
      height: 68px;
      padding: 0 12px;
      line-height: 68px;
      background: #204192;

      .topbar-logo {
        img {
          width: 40px;
          height: 35px;
        }

        .topbar-title {
          margin: 0 20px 0 10px;
          font-size: 20px;
          // font-weight: bolder;
          color: #fff;
        }
      }
      .topbar-search{
        display: flex;
        font-size: 16px;
        flex-wrap: nowrap;
        width: 260px;
      }
      .topbar-account {
        display: flex;
        font-size: 16px;
        flex-wrap: nowrap;

        .sise {
          color: #fff;
          margin-right: 8px;

          i {
            margin-right: 5px;
            margin-left: 10px;
          }
        }

        .fourfigure {
          color: #fff;
          margin-right: 15px;

          i {
            display: inline-block;
            margin-right: 5px;
          }
        }

        .leadership {
          color: #fff;
          margin-right: 30px;
        }

        .video {
          color: #fff;
          margin-right: 30px;

          i {
            display: inline-block;
            margin-right: 5px;
          }
        }

        .message {
          display: inline-block;
          width: 30px;
          height: 30px;
          margin-left: 10px;
          background: url(../assets/images/message.png) no-repeat;
          background-size: 30px;
        }

        .message2 {
          display: inline-block;
          color: #fff;
          margin-left: 10px;
          cursor: pointer;
        }

        .messages {
          margin-right: 15px;
          color: #fff;

          i {
            font-size: 20px;
            margin-right: 6px;
          }
        }

        .helper {
          margin-right: 20px;
          color: #fff;

          i {
            font-size: 20px;
            margin-right: 6px;
          }
        }
      }

      .userinfo-inner {
        font-size: 14px;
        margin-right: 28px;
        display: inline-block;
        cursor: pointer;
        color: #fff;
        padding-left: 10px;

        i.el-icon-user-solid {
          font-size: 20px;
          margin-right: 6px;
          vertical-align: middle;
        }

        i.el-icon-arrow-down {
          vertical-align: middle;
          font-size: 18px;
          margin-left: 6px;
        }

        .userIcon {
          position: relative;
          top: 10px;
          display: inline-block;
          width: 30px;
          height: 30px;
          background: url(../assets/images/user.png) no-repeat;
          background-size: 30px;
        }
      }
    }

    .main {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      position: absolute;
      top: 68px;
      bottom: 0px;
      overflow: hidden;

      aside {
        min-width: 50px;
        background: #fff;
        position: relative;

        &::-webkit-scrollbar {
          display: none;
        }

        &.showSidebar {
          overflow-x: hidden;
          overflow-y: auto;
        }
      }

      .menu-toggle {
        position: absolute;
        right: -15px;
        top: 50%;
        width: 15px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        border-radius: 0 5px 5px 0;
        background-color: #e8e8e8;
        border: 1px solid #f00;
        z-index: 100;
        transform: translate(20%, -50%);

        i::before {
          content: '';
          background-color: #f5f5f5;
          display: inline-block;
          line-height: normal;
          width: 8px;
          height: 13px;
          background: url(../assets/images/main/icon_arrowright.png) no-repeat center center;
        }

        i.fa-rotate-90::before {
          transform: rotate(90deg);
        }
      }
    }

    .content-container {
      position: relative;
      background: #f5f5f5;
      width: calc(100% - 264px);
      box-sizing: border-box;
      transition: 0.5s;

      &.iscop {
        width: calc(100% - 60px);
      }

      #elmain {
        height: calc(100% - 50px);
        padding: 0;

        .bg {
          background: #fff;
          overflow: hidden;
        }
      }

      footer {
        height: 50px;
        margin: 0 21px;
        line-height: 50px;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        color: #204192;

        box-sizing: border-box;
      }
    }
  }
  .custom-select  /deep/ .el-input__inner{
    border-radius:15px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue